/**
 * ポイント確認モーダル
 * シンプルポイントアプリと連携して、注文前にポイント利用を確認
 */

// ポイント残高を取得（シンプルポイントアプリのMetafieldから）
function getCustomerPoints() {
  // window.customerData は Liquid から渡される
  if (!window.customerData) {
    console.warn('[Point Modal] window.customerData が存在しません');
    return 0;
  }
  
  
  // 🔍 デバッグ情報を表示
  if (window.customerData._debug) {
  }
  
  // 複数の可能性を試す
  const possiblePoints = [
    window.customerData.points,
    window.customerData.pointsCustom,
    window.customerData.pointsUnreact,
    window.customerData.pointsApp,
    window.customerData.pointsSimplepoint
  ];
  
  
  // 0以外の最初の値を返す
  for (const points of possiblePoints) {
    if (points && !isNaN(parseInt(points)) && parseInt(points) > 0) {
      return parseInt(points);
    }
  }
  
  console.warn('[Point Modal] ポイントが見つかりませんでした。全候補:', possiblePoints);
  return 0;
}

// ポイント確認モーダルを表示
window.showPointConfirmationModal = function(orderData) {
  const { totalPrice, result, selection } = orderData;
  const availablePoints = getCustomerPoints();

  // 使用可能な最大ポイント（1pt = 1円、合計金額まで、API上限まで）
  // useLimitUnlimitedがtrueの場合は上限なし（999999）
  const isUnlimited = window.pointSettings?.useLimitUnlimited === true;
  const apiPointLimit = isUnlimited ? 999999 : (window.pointSettings?.useLimit || 10000);
  const maxUsablePoints = Math.min(availablePoints, Math.floor(totalPrice), apiPointLimit);

  const productName = window.currentProductInfo?.title || '商品';
  const customTitle = (window.productCustomTitle && typeof window.productCustomTitle.getValue === 'function')
    ? window.productCustomTitle.getValue()
    : '';

  function escapeHtml(str) {
    return String(str || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  const customTitleHtml = customTitle
    ? `<div class="summary-product-custom-title">
        <span class="summary-product-custom-label">商品タイトル</span>
        <span class="summary-product-custom-value">${escapeHtml(customTitle)}</span>
      </div>`
    : '';

  // モーダルHTML生成
  const modalHtml = `
    <div id="point-modal" class="point-modal-overlay">
      <div class="point-modal-content">
        <div class="point-modal-header">
          <h2>ご注文内容の確認</h2>
          <button class="point-modal-close" aria-label="閉じる">&times;</button>
        </div>

        <div class="point-modal-body">
          <div class="order-summary">
            <div class="summary-product">
              <p class="summary-product-label">商品</p>
              <p class="summary-product-name">${escapeHtml(productName)}</p>
              ${customTitleHtml}
            </div>

            <div class="summary-meta">
              <div class="summary-item">
                <span>数量</span>
                <span>${selection.quantity}部</span>
              </div>
              <div class="summary-item summary-total">
                <span>合計金額</span>
                <span class="price">¥${totalPrice.toLocaleString()}</span>
              </div>
            </div>
          </div>

          <div class="point-section">
            <div class="point-balance">
              <span class="point-label">保有ポイント</span>
              <span class="point-value">${availablePoints.toLocaleString()}pt</span>
            </div>

            <div class="point-usage">
              <label class="point-checkbox-label">
                <input type="checkbox" id="use-points-checkbox" class="point-checkbox">
                <span>ポイントを利用する</span>
              </label>

              <div id="point-input-section" class="point-input-section" style="display: none;">
                <div class="point-input-wrapper">
                  <input
                    type="number"
                    id="point-amount-input"
                    class="point-input"
                    min="1"
                    max="${maxUsablePoints}"
                    value="${maxUsablePoints}"
                    placeholder="利用ポイント数"
                  >
                  <span class="point-unit">pt</span>
                </div>
                <p class="point-note">利用可能: 最大 ${maxUsablePoints.toLocaleString()}pt（1pt = 1円）</p>
                ${apiPointLimit < 999999 ? `<p class="point-limit-note">※1回の注文で使用できるポイントは${apiPointLimit.toLocaleString()}ポイントまでです</p>` : ''}
              </div>
            </div>

            <div class="price-breakdown">
              <div class="breakdown-item point-discount-item" id="point-discount-row" style="display: none;">
                <span>ポイント割引</span>
                <span class="discount-amount" id="point-discount-amount">- ¥0</span>
              </div>
              <div class="breakdown-item final-price-item">
                <span class="final-label">お支払い額</span>
                <span class="final-amount" id="final-amount">¥${totalPrice.toLocaleString()}</span>
              </div>
            </div>
          </div>
        </div>

        <div class="point-modal-footer">
          <button id="cancel-order-btn" class="btn-secondary">キャンセル</button>
          <button id="confirm-order-btn" class="btn-primary">この内容で注文する</button>
        </div>
      </div>
    </div>
  `;

  // モーダルをDOMに追加
  document.body.insertAdjacentHTML('beforeend', modalHtml);

  // イベントリスナー設定
  setupModalEvents(totalPrice, maxUsablePoints, apiPointLimit, isUnlimited, availablePoints);

  // モーダル表示アニメーション
  requestAnimationFrame(() => {
    const modal = document.getElementById('point-modal');
    if (modal) {
      modal.classList.add('active');
    }
  });
}

// モーダルイベント設定
function setupModalEvents(totalPrice, maxUsablePoints, apiPointLimit, isUnlimited, availablePoints) {
  const modal = document.getElementById('point-modal');
  const usePointsCheckbox = document.getElementById('use-points-checkbox');
  const pointInputSection = document.getElementById('point-input-section');
  const pointAmountInput = document.getElementById('point-amount-input');
  const discountRow = document.getElementById('point-discount-row');
  const discountAmount = document.getElementById('point-discount-amount');
  const finalAmount = document.getElementById('final-amount');
  const closeBtn = modal.querySelector('.point-modal-close');
  const cancelBtn = document.getElementById('cancel-order-btn');
  const confirmBtn = document.getElementById('confirm-order-btn');
  
  // 価格表示を更新
  function updatePriceDisplay(pointsToUse) {
    const discount = Math.min(pointsToUse, maxUsablePoints);
    const finalPrice = totalPrice - discount;
    
    if (discount > 0) {
      discountRow.style.display = 'flex';
      discountAmount.textContent = `- ¥${discount.toLocaleString()}`;
    } else {
      discountRow.style.display = 'none';
    }
    
    finalAmount.textContent = `¥${finalPrice.toLocaleString()}`;
  }
  
  // チェックボックス切り替え
  usePointsCheckbox.addEventListener('change', (e) => {
    const isChecked = e.target.checked;
    pointInputSection.style.display = isChecked ? 'block' : 'none';
    
    if (isChecked) {
      pointAmountInput.value = maxUsablePoints;
      updatePriceDisplay(maxUsablePoints);
    } else {
      updatePriceDisplay(0);
    }
  });
  
  // ポイント入力変更
  pointAmountInput.addEventListener('input', (e) => {
    const inputValue = parseInt(e.target.value) || 0;
    let value = inputValue;

    // 範囲チェック
    if (value < 0) value = 0;

    // 上限超過チェック
    if (inputValue > maxUsablePoints) {
      value = maxUsablePoints;
      // 上限超過時にアラート表示
      if (inputValue > apiPointLimit && !isUnlimited) {
        alert(`1回の注文で使用できるポイントは${apiPointLimit.toLocaleString()}ポイントまでです。\n入力値を${maxUsablePoints.toLocaleString()}ポイントに調整しました。`);
      } else if (inputValue > availablePoints) {
        alert(`保有ポイント（${availablePoints.toLocaleString()}pt）を超えています。\n入力値を${maxUsablePoints.toLocaleString()}ポイントに調整しました。`);
      }
    }

    e.target.value = value;
    updatePriceDisplay(value);
  });
  
  // モーダルを閉じる関数
  function closeModal() {
    modal.classList.remove('active');
    setTimeout(() => {
      modal.remove();
    }, 300);
  }
  
  // 閉じるボタン
  closeBtn.addEventListener('click', closeModal);
  
  // キャンセルボタン
  cancelBtn.addEventListener('click', closeModal);
  
  // モーダル外クリックで閉じる
  modal.addEventListener('click', (e) => {
    if (e.target === modal) {
      closeModal();
    }
  });
  
  // 注文確定ボタン
  confirmBtn.addEventListener('click', () => {
    const usePoints = usePointsCheckbox.checked;
    const pointsToUse = usePoints ? parseInt(pointAmountInput.value) || 0 : 0;
    
    
    // モーダルを閉じる
    closeModal();
    
    // Draft Order作成に進む
    if (typeof window.confirmOrderWithPoints === 'function') {
      window.confirmOrderWithPoints(pointsToUse);
    } else {
      console.error('[Point Modal] confirmOrderWithPoints 関数が見つかりません');
    }
  });
};


